var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({class:_vm.color,attrs:{"x-small":"","icon":""},on:{"click":function($event){return _vm.$emit('click')}}},on),[_c('v-icon',{attrs:{"x-small":""}},[_vm._v(" reorder ")])],1)]}}])},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }